function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100",
  version: "1.1",
  id: "Ebene_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0",
  y: "0",
  viewBox: "0 0 612.33 158",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#002851",
  d: "M247.53 96.76a36.432 36.432 0 01-12.19 2.11c-13.06 0-20.74-8.17-20.74-21.12 0-14.4 9.02-21.41 20.64-21.41 4.22-.03 8.39.79 12.29 2.4l2.97-11.62c-2.59-1.34-8.35-2.88-15.94-2.88-19.58 0-35.33 12.29-35.33 34.37 0 18.43 11.52 32.35 33.89 32.35 7.87 0 13.92-1.44 16.61-2.78l-2.2-11.42zm37.44-52.52c-19.1 0-31.49 14.5-31.49 33.89 0 18.43 11.23 32.93 30.43 32.93 18.91 0 31.78-12.86 31.78-34.08 0-17.86-10.85-32.74-30.72-32.74zm-.39 11.62c10.08 0 15.65 9.98 15.65 21.6 0 12.58-5.66 21.98-15.55 21.98-9.79 0-15.74-8.93-15.74-21.6 0-12.58 5.76-21.98 15.64-21.98zM338.73 110V90.51c0-10.56-.19-19.68-.58-28.22l.29-.1c3.34 7.81 7.09 15.44 11.23 22.85L363.5 110h15.36V45.3h-13.44v18.91c-.09 9.01.33 18.01 1.25 26.98h-.29c-3.03-7.61-6.56-15.02-10.56-22.18L342.38 45.3h-17.09V110h13.44zm66.24 0V90.51c0-10.56-.19-19.68-.58-28.22l.29-.1c3.34 7.81 7.09 15.44 11.23 22.85L429.74 110h15.36V45.3h-13.44v18.91c-.09 9.01.32 18.01 1.24 26.97h-.29c-3.03-7.61-6.56-15.02-10.56-22.18l-13.43-23.7h-17.09V110h13.44zm91.3-39.26h-23.81V57.3h25.24v-12h-39.93V110h41.28V98h-26.59V82.64h23.81v-11.9zm58.08 26.01a36.432 36.432 0 01-12.19 2.11c-13.06 0-20.74-8.16-20.74-21.12 0-14.4 9.02-21.41 20.64-21.41 4.22-.03 8.39.79 12.29 2.4l2.97-11.62c-2.59-1.34-8.35-2.88-15.94-2.88-19.58 0-35.33 12.29-35.33 34.37 0 18.43 11.52 32.35 33.89 32.35 7.87 0 13.92-1.44 16.61-2.78l-2.2-11.42zM579.98 110h14.69V57.58h17.66V45.3H562.6v12.29h17.38V110z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00929E",
  d: "M145.86 63.06L162.95 110h14.59l17.47-46.94h-15.36l-6.05 21.79c-1.06 4.03-1.82 7.58-2.59 11.42h-.29c-.69-3.85-1.59-7.67-2.69-11.42l-6.34-21.79h-15.83z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#00929E",
  cx: "70",
  cy: "71",
  r: "28"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#00929E",
  cx: "102",
  cy: "137",
  r: "21"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#00929E",
  cx: "17",
  cy: "34",
  r: "17"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#00929E",
  cx: "129.5",
  cy: "15.5",
  r: "15.5"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#002851",
  cx: "32.5",
  cy: "108.5",
  r: "14.5"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#002851",
  cx: "62",
  cy: "21",
  r: "12"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00929E",
  d: "M69.65 72.74l-44-30 1.69-2.48 44 30-1.69 2.48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00929E",
  d: "M71.53 72.59l-2.06-2.18 53-50 2.06 2.18-53 50z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00929E",
  d: "M101.15 138.15l-32-66 2.7-1.31 32 66-2.7 1.31z"
})));